export const SERVICE_APP_NAME = {
  NESS: 'NESS',
  NBOX: 'NBOX',
  DF: 'DF',
  MARPPLE: 'MARPPLE',
  MARPPLE_SHOP: 'MARPPLE_SHOP',
};
